<script lang="ts" setup>
// #上一張圖片，下三張圖片
import { type Image } from '@/utils/types/Image'
const props = defineProps({
  data: {
    type: Object
  }
})

const imgData1 = ref()
const imgData2 = ref()

if (props.data) {
  const img1: Ref<Image> = ref(props.data.image_top)
  const img2: Ref<Image> = ref(props.data.image_bottoms)
  imgData1.value = img1.value
  imgData2.value = img2.value
}
</script>

<template>
  <div class="area">
    <figure class="area__top">
      <Nimg :src="imgData1?.link" :title="imgData1?.title" :alt="imgData1?.alt" format="wep" />
    </figure>
    <div class="area__bottom">
      <figure class="area__pic" v-for="(item, index) in imgData2" :key="index">
        <Nimg :src="item?.link" :title="item?.title" :alt="item?.alt" format="wep" />
      </figure>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.area {
  padding-top: toRem(20);
  padding-bottom: toRem(20);

  @include max-media(480) {
    flex-wrap: wrap;
  }

  img {
    display: block;
    width: 100%;
  }

  &__top {
    width: 66%;
    margin-bottom: toRem(22);
  }

  &__bottom {
    display: flex;
    justify-content: space-between;
  }

  &__pic {
    width: calc((100% - toRem(46)) / 3);

    @include max-media(480) {
      width: 33.3333%;
    }
  }
}
</style>
